import '~style/blocks/team-profiles/index.scss';
import '~style/components/modal-window/_modal-team-member.scss';
import TeamMemberModal from './team-member-modal';

TeamMemberModal.init();
